import { IBulkactionData } from '../../services/shifts.service';
import { AuthUserService } from '../../authsettings/services/authusers.service';
import { AppService } from '../../main/app.service';
import { Masterdata } from '../../services';
import { IShift, ShiftService, EmployeesService, IGetShiftListParams } from '../../services';
import * as moment from 'moment';
import * as _ from 'lodash';

class ShiftListController implements ng.IComponentController {
    endList: boolean;
    loading: boolean;
    shiftLoading: any;
    private user: any;
    private groupedShifts: IShift[] = [];
    private moment: any;
    private actionform: any;
    private selectAll: any;
    private isMessageOpen: boolean;
    private sortType: any;
    private shiftsGrouping: string;
    private filter: any;
    private statuses: Masterdata[];
    private functions: Masterdata[];
    private shifts: IShift[];
    private currentShift: IShift;
    private months: Array<String>;
    private startDate: any;
    private endDate: any;
    private days: any = [];
    private teams: any = [];
    private employees: any;
    //private selectedEmployee: any;
    private handlingChildChange: boolean;

    constructor(
        private ShiftService: ShiftService,
        private EmployeesService: EmployeesService,
        private ThemeAppService: aboTheme.IThemeAppService,
        private $scope: ng.IScope,
        private $state: ng.ui.IStateService,
        private SweetAlert: any,
        private $timeout: ng.ITimeoutService,
        private $filter: any,
        private $sce: ng.ISCEService,
        private AuthUserService: AuthUserService,
        private $stateParams: ng.ui.IStateParamsService
    ) {
        'ngInject';

        this.months = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
    }

    public $onInit = () => {
        this.isMessageOpen = false;
        this.shiftsGrouping = 'date';

        ///console.log(this.$stateParams);

        this.$scope.$watchCollection(() => {
            return this.$state.params;
        }, () => {
            if(this.$stateParams['refreshShift']) {
                this.refreshShift(this.$stateParams['refreshShift']);
                this.$state.go(".", { "refreshShift": '' }, { notify: false });
            }
        });

        this.filter = {
            status: null
        }

        var date = moment();
        if (this.$stateParams['start']) {
            date = moment(this.$stateParams['start']);
            this.startDate = date.format("YYYY-MM-DD");
            if (this.$stateParams['end']) {
                this.endDate = moment(this.$stateParams['end']).format("YYYY-MM-DD");
            } else {
                this.endDate = date.add(1, 'M').format("YYYY-MM-DD");
            }
        } else {
            this.startDate = date.format("YYYY-MM-DD");
            this.endDate = date.add(1, 'M').format("YYYY-MM-DD");
        }

        this.AuthUserService.getCurrentUser().then((user) => {
            this.user = user;
        });

        this.getShiftsByDate();
    }

    public $onDestroy = () => {
        this.ShiftService.unsubscribe('ShiftListController');
    }

    private refreshShift(id) {
        this.ShiftService.get(id).then(shift => {
            var index = _.findIndex(this.shifts, { id: id });
            this.shifts[index] = shift;
            this.filterShifts();
        })
    }


    private isSameDay = (start, end) => {
        if (moment(start).toDate().getDate() == moment(end).toDate().getDate()) {
            return true;
        } else {
            return false;
        }
    }

    private getShiftsByDate = () => {
        this.$state.go(".", { "start": this.startDate, "end": this.endDate }, { notify: false });
        this.shifts = [];
        this.getShifts();
    }

    private prevWeek = () => {
        this.startDate = moment(this.startDate).add(-7, 'day').toDate();
        this.endDate = moment(this.endDate).add(-7, 'day').toDate();
        this.shifts = [];
        this.getShiftsByDate();
    }

    private nextWeek = () => {
        
        this.startDate = moment(this.startDate).add(7, 'day').toDate();
        this.endDate = moment(this.endDate).add(7, 'day').toDate();
        this.shifts = [];
        this.getShiftsByDate();
    }

    public resetFilters = () => {
        this.filter = {
            search: null,
            status: null,
            createdby: null,
            createdsince: null
        }
        this.shifts = [];
        this.getShifts();
    }

    public nextPage = () => {
        this.loading = true;
        this.getShifts(true, this.shifts.length);
    }

    public setFilters = (resetTime = true) => {
        this.loading = true;
        this.shifts = [];
        if (resetTime) {
            this.filter.createdsince = null;
            this.filter.updatedsince = null;
        }
        this.getShifts(true, 0);
    }

    public getShifts = (scrollTo = true, offset = 0) => {
        this.loading = true;
        var params: IGetShiftListParams = {
            from: this.startDate,
            till: this.endDate,
            includeSubscriptions: true,
            sortfield: 'start',
            sortorder: 'asc',
            limit: 25,
            offset: offset
        }

        if (this.filter) {
            if (this.filter.status) {
                params.status = this.filter.status;
            }
            if (this.filter.search && this.filter.search.length > 3) {
                params.q = this.filter.search;
            }
            if (this.filter.createdby) {
                params.createdBy = this.filter.createdby;
                // params.updatedBy = this.filter.createdby;
            }
            if (this.filter.createdsince) {
                params.createdSince = this.filter.createdsince;
                params.updatedSince = this.filter.createdsince;
            }
        }

        if (!this.shiftLoading) {
            this.shiftLoading = true;
            if (!this.shifts) {
                this.shifts = [];
            }
            this.ShiftService.getFilter(params).then((result) => {
                result.forEach(item => {
                    this.shifts.push(item);
                })
                //this.shifts = [...result];
                this.getTeams();
                this.filterShifts(scrollTo);
                this.shiftLoading = false;
                if (result.length >= 25) {
                    this.loading = false;
                } else {
                    this.endList = true;
                }
            });
        }
    }

    public filterShifts = (scrollTo = true) => {

        // this.shifts = this.$filter('filter')(this.shifts, this.filter.search);

        if (this.shiftsGrouping && this.shiftsGrouping == 'date') {
            this.groupedShifts = _.groupBy(this.shifts, (item) => {
                return moment(item.start).format('dd DD-MM-YYYY');
            });
        }

        if (!this.shifts.length) {
            // this.$state.go("shifts.list");
        } else if (this.currentShift) {
            if (!_.find(this.shifts, { id: this.currentShift.id }) && !this.handlingChildChange) {
                // this.$state.go(this.$state.current, { id: this.shifts[0].id });
                // this.currentShift = this.shifts[0];
                // this.$timeout(() => {
                //     if (this.isMessageOpen && scrollTo) {
                //         this.scrollToShift(this.currentShift.id);
                //     }
                // });
            } else {
                this.$timeout(() => {
                    if (this.handlingChildChange) {
                        this.handlingChildChange = false;
                    }
                    if (this.isMessageOpen && scrollTo) {
                        this.scrollToShift(this.currentShift.id);
                    }
                });
            }
        }
    }

    // private mailTeam = (team) => {

    //     var ids = [];
    //     this.shifts.forEach(s => {
    //         if (s.teamName && s.teamName == team && ids.find(id => id == s.id) == null) {
    //             ids.push(s.id);
    //         }
    //     });

    //     this.ShiftService.customPost('email/team', ids);
    // }

    private notifyTeam = () => {
        this.ShiftService.customPost('email/team', [this.currentShift.id]);
    }

    private notifyEmployee = () => {
        this.ShiftService.customPost('email/employee', [this.currentShift.id]);
    }

    private getTeams = () => {
        this.shifts.forEach(s => {
            if (this.teams.indexOf(s.teamName) == -1) {
                this.teams.push(s.teamName);
            }
        });
    }

    public handleChildChange = (type, data) => {
        // console.log('handleChildChange')
        // console.log(type)
        this.handlingChildChange = true;
        switch (type) {
            case 'open':
                this.isMessageOpen = true;
                this.currentShift = data;
                break;
            case 'close':
                this.isMessageOpen = false;
                break;
            case 'new':
                this.setFilters();
                break;
            case 'updated':
                this.setFilters();
                break;
            case 'deleted':
                this.setFilters();
                break;
            case 'copy':
                this.setFilters(false);
                break;
        }
    }

    public scrollToShift = (shiftID) => {
        // var target_offset = $("#s-" + shiftID).offset();
        // var parent_offset = $('#shiftsmalllist').offset();
        // var target_top = target_offset.top - parent_offset.top - 10;
        // $('#shiftsmalllist').animate({ scrollTop: target_top }, 500);
    }

    public selectAllChange = () => {
        this.shifts.forEach(shift => {
            (<any>shift).$selected = this.selectAll;
        })
    }

    public submitAction = () => {
        var shifts = _.filter(this.shifts, { $selected: true });
        var data = new IBulkactionData();
        data.ids = [];
        shifts.forEach((shift) => {
            data.ids.push(shift.id);
        });
        var text = '';

        switch (this.actionform.action) {
            case 'setstatus':
                var status = this.actionform.status;
                data.shiftBulkAction = "ChangeStatus";
                data.statusId = status.code;
                text = 'Weet u zeker dat u van alle ' + shifts.length + ' geselecteerde diensten de status op ' + status.name + ' wilt zetten?';
                break;
            case 'emailteam':
                data.shiftBulkAction = "SendEmail";
                data.shiftEmail = "Customer";
                text = 'Weet u zeker dat u  alle ' + shifts.length + ' geselecteerde diensten wilt mailen naar team?';
                break;
            case 'emailemployee':
                data.shiftBulkAction = "SendEmail";
                data.shiftEmail = "EmployeeConfirm";
                text = 'Weet u zeker dat u  alle ' + shifts.length + ' geselecteerde diensten wilt mailen naar de medewerkers?'
                break;;
            case 'setemployee':
                var employee = this.actionform.employee;
                data.shiftBulkAction = "SetEmployee";
                data.employeeId = employee.id;
                text = 'Weet u zeker dat u  alle ' + shifts.length + ' geselecteerde diensten wilt toewijzen aan ' + employee.displayName + '?';
                break;
            case 'delete':
                data.shiftBulkAction = "Delete";
                text = 'Weet u zeker dat u  alle ' + shifts.length + ' geselecteerde diensten wilt verwijderen?';
                break;
        }

        this.SweetAlert.swal({
            title: 'Let op!',
            text: text,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.ShiftService.bulkAction(data).then(() => {
                    this.actionform.action = "";
                    this.shifts = [];
                    this.getShifts();
                });
            } else {

            }
        });
    }
}

export const shiftListComponent: ng.IComponentOptions = {
    bindings: {
        statuses: '<',
        functions: '<',
        employees: '<'
    },
    controller: ShiftListController,
    template: <string>require('./shift.list.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/shifts/shift.list.component.ts